export enum MudancasTrabalhadoresTipoEnum {
    CARGO = 2,
	DEPARTAMENTO = 3,
	ESTABELECIMENTO = 4,
	HORARIO = 5,
	LOTACAO = 6,
}
